// src/components/CustomerSummary/components/TurnaroundTimesTable.jsx
// ============================================================================
// BLOCK CS.UI.TAT.0 — TurnaroundTimesTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 3 columns)
// - Optional prelude lines:
//     "Facility: ..."
//     "Date Range: ..."
// - Rows:
//     <Metric>\t<Study Type>\t<Value>
// - Group header rows:
//     <Metric>\t\t
// - Nested rows (under same metric):
//     \t<Study Type>\t<Value>
// ============================================================================

import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

function safeStr(v) {
  return v === null || v === undefined ? '' : String(v);
}

function isPreludeLine(line) {
  const s = safeStr(line).trim();
  return s.startsWith('Facility:') || s.startsWith('Date Range:');
}

export default function TurnaroundTimesTable({ text, columnWidths, onColumnWidthsChange }) {
  const { prelude, body } = React.useMemo(() => {
    const lines = safeStr(text)
      .split(/\r?\n/)
      .map((l) => safeStr(l));
    const preludeLines = lines
      .filter((l) => isPreludeLine(l))
      .map((l) => l.trim())
      .filter(Boolean);
    const bodyLines = lines.filter((l) => l.trim().length > 0).filter((l) => !isPreludeLine(l));
    return { prelude: preludeLines, body: bodyLines.join('\n') };
  }, [text]);

  return (
    <Box>
      {prelude.length ? (
        <Box sx={{ paddingBottom: 1 }}>
          {prelude.map((l) => (
            <Typography key={l} variant="body2" sx={{ fontSize: 13, opacity: 0.85 }}>
              {l}
            </Typography>
          ))}
        </Box>
      ) : null}

      <ResizableTextTable
        text={body}
        columnWidths={columnWidths}
        onColumnWidthsChange={onColumnWidthsChange}
        format={TABLE_FORMATS.turnaroundTimes}
      />
    </Box>
  );
}
